import { forwardRef, type SelectHTMLAttributes } from 'react'
import { cn } from '../../lib/cn'

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, label, id, children, ...props }, ref) => {
    const selectId = id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined)
    return (
      <label className="block" htmlFor={selectId}>
        {label && (
          <span className="mb-[7px] block font-mono text-[11px] uppercase tracking-label text-ink-faint">
            {label}
          </span>
        )}
        <select
          ref={ref}
          id={selectId}
          className={cn(
            'w-full box-border rounded-input border border-line bg-paper-surface px-[14px] py-3 text-[14px] font-sans text-ink outline-none focus:border-terra',
            className,
          )}
          {...props}
        >
          {children}
        </select>
      </label>
    )
  },
)
Select.displayName = 'Select'
